export enum FieldType {
  INPUT = 'input',
  SELECT = 'select',
  SWITCH = 'switch',
  CHECKBOX = 'checkbox',
  ELEMENT = 'element',
  LOCATION_MODAL = 'locationModal',
  FEED_LOCATION_MODAL = 'feedLocationModal',
}

export enum SwitchLabelPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum FormType {
  FORMIK = 'formik',
  REACT_HOOK_FORMS = 'reactHookForms',
}
